import axiosInstance from './axios';
import { Product, ProductDetail } from '../types/product';

export const productsAPI = {
  getProducts: async (params?: {
    category_id?: number;
    search?: string;
    min_price?: number;
    max_price?: number;
    skip?: number;
    limit?: number;
  }): Promise<ProductDetail[]> => {
    const response = await axiosInstance.get('/products/', { params });
    return response.data;
  },

  getProductDetail: async (productId: number): Promise<ProductDetail> => {
    const response = await axiosInstance.get(`/products/${productId}`);
    return response.data;
  },

  getRecommendedProducts: async (limit: number = 8): Promise<ProductDetail[]> => {
    const response = await axiosInstance.get('/products/recommended', {
      params: { limit },
    });
    return response.data;
  },
};